<template>
    <div :class="`bg-toast ${showToastConfirm ? 'active' : ''} text-dark border-0`" role="alert" aria-atomic="true">
        <div class="toast">
            <div class="toast-icon">
                <i :class="`fas fa-${icon}`"></i>
            </div>
            <div class="toast-body" v-html="message">
                <!-- {{ message }} -->
            </div>
            <button
                @click="closeToast()"
                :class="`bg-${theme} ${icon == 'exclamation' ? 'text-dark' : 'text-white'}`"
                type="button" data-bs-dismiss="toast" aria-label="Close"
            >
                OK
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
    name: 'ToastConfirm',
    methods: {
        ...mapActions("toast", [
            "setShowToastConfirm",
            "setTimerToast"
        ]),
        closeToast() {
            this.setShowToastConfirm(false)
            if(this.callback) {
                this.callback()
            }
        }
    },
    computed: {
        ...mapState("toast", [
            "showToastConfirm",
            "message",
            "icon",
            "theme",
            "timer",
            "callback"
        ])
    }
}
</script>

<style scoped>
.bg-toast {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 0%;
    background: transparent;
    z-index: 9998;
}
.bg-toast.active {
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
}
.toast {
    margin: auto;
    transform: translateY(-100%);
    transition: all 0.3s cubic-bezier(0.68, 0, 0.265, 1.35);
    padding: 1rem 1.8rem;
    border-radius: 0.25rem;
    width: 100%;
    max-width: 400px;
    z-index: 9999;
    height: auto;
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bg-toast.active .toast {
    transform: translateY(0%);
}

.toast .toast-icon {
    font-size: 7rem;
    color: rgba(0, 0, 0, 0.3);
}

.fa-exclamation {
    color: #ffc107;
}

.toast .toast-body {
    font-size: 1.8rem;
    text-align: center;
    padding-block: 2rem;
}

.toast button {
    border: none;
    outline: none;
    padding: 1rem 2rem;
    cursor: pointer;
    font-weight: 600;
    border-radius: 0.25rem;
    transition: 0.2s;
    font-size: 1.5rem;
}
</style>
